import { render, staticRenderFns } from "./DealsPage.vue?vue&type=template&id=d00e87e6&scoped=true&"
import script from "./DealsPage.vue?vue&type=script&lang=js&"
export * from "./DealsPage.vue?vue&type=script&lang=js&"
import style0 from "./DealsPage.vue?vue&type=style&index=0&id=d00e87e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00e87e6",
  null
  
)

export default component.exports